<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-name">Contents</p>
<ul>
<li><a href="#/Text/Preface2015">Preface to the 2015 Edition</a></li>
<li><a href="#/Text/Preface">Preface to the First Edition (1986)</a></li>
<li><a href="#/Text/Introduction">Introduction (2002)</a></li>
<li><span href="#/Text/Chapter1" title="Link target outside of Sample">1. Thought Control: The Case of the Middle East</span></li>
<li><span href="#/Text/Chapter2" title="Link target outside of Sample">2. Middle East Terrorism and the American Ideological System</span></li>
<li><span href="#/Text/Chapter3" title="Link target outside of Sample">3. Libya in U.S. Demonology (1986)</span></li>
<li><span href="#/Text/Chapter4" title="Link target outside of Sample">4. The U.S. Role in the Middle East (November 15, 1986)</span></li>
<li><span href="#/Text/Chapter5" title="Link target outside of Sample">5. International Terrorism: Image and Reality (1989)</span></li>
<li><span href="#/Text/Chapter6" title="Link target outside of Sample">6. The World after September 11 (2001)</span></li>
<li><span href="#/Text/Chapter7" title="Link target outside of Sample">7. U.S./Israel–Palestine (May 2001)</span></li>
<li><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></li>
<li><span href="#/Text/Author" title="Link target outside of Sample">About the Author</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?024ecd23